import React from 'react';
import AdvertisementPaymentContainer from 'containers/AdvertisementPaymentContainer';

export default function AdvertisementPaymentPage() {
  return <AdvertisementPaymentContainer />;
}
